import FormikContextInputField from '../../../../../components/formikFileds/FormikContextInputField';
import {convertToPersianDate} from '../../../../../utilities/helper/GetPersianDateTime';
import {toEnglishDigits} from '../../../../../utilities/helper/toEnglishNumber';
import {getPersianOrdinal} from '../../../../../utilities/helper/unitConvertor/getPersianOrdinal';
import {ICheckPriceData} from '../credit-loan/Forms/MultiPersonForm/EditPersonForm';
import {IBankDocsGeneralForm} from '../credit-loan/LoanDocsPage';
import {AddressItem} from './CompanyAddressData';

interface IProps {
  checkPriceData: ICheckPriceData;
  checkDate: string;
  receiverName: string;
  MeliCardId: string;
  fieldPrefix: keyof IBankDocsGeneralForm;
  selfCheckCounts: number;
}

const getSayadiFieldName = (
  fieldPrefix: keyof IBankDocsGeneralForm,
  index: number,
) => {
  const map = ['first', 'second', 'third'];
  return `${fieldPrefix}.${map[index]}_digital_cheque_id`;
};

const DigitalCheckSection = ({
  checkPriceData,
  checkDate,
  receiverName,
  MeliCardId,
  fieldPrefix,
  selfCheckCounts,
}: IProps) => {
  const getPrices = (): number[] => {
    if (fieldPrefix === 'self') {
      return checkPriceData?.ownerChequePrices || [];
    }

    if (fieldPrefix === 'Guarantor-0') {
      return checkPriceData?.guarantorChequePrices?.slice(0, 1) || [];
    }

    if (fieldPrefix === 'Guarantor-1') {
      return checkPriceData?.guarantorChequePrices?.slice(1, 2) || [];
    }

    return [];
  };

  const getPriceTitle = (index: number, isSingle: boolean) => {
    if (fieldPrefix !== 'self') return 'مبلغ چک';

    if (isSingle) return 'مبلغ چک';

    const titles = ['مبلغ چک اول', 'مبلغ چک دوم', 'مبلغ چک سوم'];

    return titles[index] ?? 'مبلغ چک';
  };

  const prices = getPrices();

  const priceItems = prices.map((price, index) => ({
    icon: 'icon-namemoney',
    title: getPriceTitle(index, prices.length === 1),
    value: `${price.toLocaleString()} تومان`,
  }));

  const addressData = [
    ...priceItems,
    {
      icon: 'icon-nameCalendar',
      title: 'تاریخ سر رسید',
      value: convertToPersianDate(checkDate)?.toString()!,
    },
    {
      icon: 'icon-size2478',
      title: 'نام دریافت کننده',
      value: receiverName,
    },
    {
      icon: 'icon-nameBank-Card',
      title: 'شناسه ملی دریافت کننده',
      value: MeliCardId,
    },
  ];

  const inputLabels = selfCheckCounts > 1 ? 'شماره چک ها' : 'شماره چک';

  const FieldsNumbers = fieldPrefix === 'self' ? selfCheckCounts : 1; // the multiple number of check is only applied when the person is self otherwise it is only one field

  const sayadiFields = Array.from({length: FieldsNumbers}, (_, index) => ({
    name: getSayadiFieldName(fieldPrefix, index),

    placeholder:
      selfCheckCounts > 1
        ? `شماره چک ${getPersianOrdinal(index + 1) ?? index + 1} را وارد کنید`
        : 'شماره چک را وارد کنید',
  }));

  return (
    <div className="flex flex-col gap-2 text-sm">
      <span>
        صدور چک <span className="text-red-600">*</span>
      </span>

      <span>
        چک دیجیتال را طبق اطلاعات زیر ثبت کنید و شماره چک را وارد کنید
      </span>

      <div className="flex flex-col gap-2 p-[1rem] mt-2 rounded-lg bg-gray-50">
        {addressData.map((item, index) => (
          <AddressItem
            key={index}
            className="grid grid-cols-[1fr,1fr] gap-4"
            icon={item.icon}
            title={item.title}
            value={item.value}
          />
        ))}
      </div>

      <div className="flex flex-col gap-0.5">
        <span className="mt-2">
          {inputLabels} <span className="text-red-600">*</span>
        </span>
        {sayadiFields.map(field => (
          <FormikContextInputField
            key={field.name}
            name={field.name}
            label={''}
            placeholder={field.placeholder}
            required
            maxLength={16}
            showRequiredStar={false}
            onChangeFormatter={toEnglishDigits}
            type="number"
            inputMode="numeric"
          />
        ))}
      </div>
    </div>
  );
};

export default DigitalCheckSection;
